// extracted by mini-css-extract-plugin
export default {"button":"profileAvatar_button__N87eG","img":"profileAvatar_img__Yr09z","editContainer":"profileAvatar_editContainer__gChXQ"};